import { useEffect, useRef } from 'react';

const useLazyLoad = (containerRef, options) => {
    const observer = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const onIntersection = (entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target;
                    const src = lazyImage.dataset.src;

                    if (src) {
                        lazyImage.src = src;
                        lazyImage.classList.remove('lazy');
                    }
                    obs.unobserve(lazyImage);
                }
            });
        };

        observer.current = new IntersectionObserver(onIntersection, options);

        const lazyImages = container.querySelectorAll('[data-src]');
        lazyImages.forEach(image => {
            observer.current.observe(image);
        });

        return () => {
            if (observer.current) {
                lazyImages.forEach(image => {
                    observer.current.unobserve(image);
                });
            }
        };
    }, [containerRef, options]);
};

export default useLazyLoad;